// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiper-slide img {
    object-fit: contain !important;
}
@media (min-width:1620px) and (max-width:1880px)
{
    .about-body .frame {
        z-index: 1 !important;
        transform: translate(-30%,-50%) !important;
    }
    .about-body .content-left-border {
        z-index: 2 !important;
        top: -5% !important;
        left: 40% !important;
    }
    .about-body .content-left {
        width: 480px !important;
    }
}
@media (min-width:1400px) and (max-width:1620px)
{
    .about-body .frame {
        z-index: 1 !important;
        transform: translate(-30%,-50%) !important;
    }
    .about-body .content-left-border {
        z-index: 2 !important;
        top: -5% !important;
        left: 35% !important;
    }
    .about-body .content-left {
        width: 380px !important;
    }
}
@media (min-width:1000px) and (max-width:1400px) {
    .header-body .stone-img {
        width: 100px !important;
    }
    .header-body .menu-icon {
        left: 53px !important;
    }
    .sidebar-body {
        top: 130px !important;
    }
    .about-body .frame {
        z-index: 1 !important;
        transform: translate(-5%,-50%) !important;
    }
    .about-body .content-left-border {
        z-index: 2 !important;
        top: -5% !important;
        left: 24% !important;
    }
    .about-body .content-left {
        width: 380px !important;
    }
    .about-swiper {
        top: -50% !important;
    }
    .about-swiper .swiper-slide {
        width: 350px !important;
        height: 250px !important;
    }
    .meetus-swiper {
        position: relative !important;
        z-index: 999999999 !important;
    }
    .meetus-swiper .swiper-slide {
        width: 200px !important;
        height: 350px  !important;
    }
    .meetus-swiper .swiper-slide img {
        width: 100% !important;
        height: 350px !important;
        object-fit: contain;
        position: absolute !important;
        z-index: 20 !important;
    }
    .doMySwiper .swiper-slide {
        width: 100% !important;
        height: 400px !important;
        object-fit: contain !important;
    }
    .doMySwiper .swiper-slide img {
        width: 500px !important;
        height: 400px !important;
        object-fit: contain;
    }
    .doMySwiper .swiper-slide img {
        width: 600px !important;
        height: 400px !important;
        object-fit: contain !important;
    }
    .doMySwiper .swiper-slide .content-left-border {
        transform: translate(20%, 70%);
    }
    .doMySwiper .swiper-slide .text-area {
        padding: 20px 20px !important;
    }
    .doMySwiper .swiper-slide h1 {
        font-size: 20px !important;
    }
    .meetus-body {
        margin-top:25px !important;
    }
    .brands-body {
        height: 103vh !important;
        background-size: cover !important;
    }
    .what-we-do-body h1 {
        font-size: 50px !important;
    }
    .brands-body .title {
        font-size: 50px !important;
    }
    .scholarship-body {
        margin-top: 100px !important;
    }
    .backbtn {
        top: 90px !important;
    }
    .nextbtn {
        top: 90px !important;
    }
    .upper-footer {
        margin-bottom: 175px !important;
    }
    .meetus-body {
        height: 160vh !important;
    }
    /* .meetus-body .mySwiper .swiper-slide{
       width: 100% !important;
       height: 400px !important;
       object-fit: contain !important;
    }
    .meetus-body .swiper-slide img {
        width: 100% !important;
       height: 400px !important;
       object-fit: contain !important;
    } */
    .scholarship-body {
        height: 130vh !important;
        background-position: center !important;
    }
    /* .footer-rock {
        width: 300px !important;
        bottom: 13% !important;
        left: 0% !important;
    } */
}
@media (min-width:1000px) and (max-width:1300px) {
    .brands-body {
        height: 84vh !important;
        background-size: cover !important;
    }
    
}
@media (min-width:1200px) and (max-width:1300px) {
    .brands-body {
        height: 103vh !important;
        background-size: cover !important;
    }
    .about-body .content-left-border {
        left: 30% !important;
    }
    .about-body .frame {
        right: 10% !important;
    }
}
@media (min-width:1300px) and (max-width:1400px) {
    .about-body .frame {
        right: 5% !important;
    }
    .about-body .content-left-border {
        left: 35% !important;
    }
    .about-swiper {
        top: -30% !important;
    }
    .brands-body {
        height: 85vh !important;
        background-size: cover !important;
    }
    .footer-rock {
        position: absolute;
        width: 400px !important;
        top: -30%;
        left: -20%;
        z-index: 1 !important;
    }
}
@media (min-width:1000px) and (max-width:1100px) {
    @media  (min-height:600px) and (max-height:650px) {
        .about-body .frame {
            right: 0% !important;
        }
        .meetus-body {
            margin-top:50px !important;
        }
        .backbtn {
            top: 90px !important;
        }
        .nextbtn {
            top: 90px !important;
        }
        .footer-rock {
            width: 200px !important;
            bottom: 13% !important;
            left: 0% !important;
        }
        .what-we-do-body .left-area .text-area {
            width: 400px !important;
        }
    }
}
@media (min-width:768px) and (max-width:820px){
    @media (min-height:1000px) and (max-height:1200px) {
        .parallax-body .intro {
            top: 45% !important;
            left: 50% !important;
        }
        .about-body {
            background-size: contain !important;
            height: 80vh !important;
        }
        .about-body .frame {
            background-size: contain !important;
            width: 400px !important;
            right: -20% !important;
            z-index: 1;
        }
        .about-body .content-left {
            width: 300px !important;
        }
        .about-body .content-left-border {
            top: -10% !important;
            left: 30% !important;
            z-index: 2 !important;
        }
        .about-body .content-right {
            padding: 50px 20px 10px 20px !important;
            font-size: 14px !important;
        }
        .about-swiper .swiper-slide {
            width: 350px !important;
            height: 250px !important;
        }
        .about-swiper {
            top: -60% !important;
        }
        .brands-body {
            background-size: cover !important;
            height: 37vh !important;
        }
        .what-we-do-body {
            height: 52vh !important;
            background-size: contain !important;
        }
        .doMySwiper .swiper-slide {
            width: 100% !important;
            height: 450px !important;
            object-fit: contain !important;
        }
        .doMySwiper .swiper-slide img {
            width: 400px !important;
            height: 400px !important;
            object-fit: contain !important;
        }
        .doMySwiper .swiper-slide .content-left-border {
            transform: translate(20%, 70%);
        }
        .doMySwiper .swiper-slide .text-area {
            padding: 20px 20px !important;
            width: 300px !important;
        }
        .what-we-do-body .left-area h1 {
            font-size: 20px!important;
        }
        .backbtn {
            top: 20% !important;
        }
        .nextbtn {
            top: 20% !important;
        }
        .brands-body .title {
            font-size: 40px !important;
        }
        .what-we-do-body h1 {
            font-size: 40px !important;
        }
        .what-we-do-body .mb-5 {
            margin-bottom: 1rem !important;
        }
    }
}
@media (min-width:1000px) and (max-width:1100px){
    @media (min-height:1300px) and (max-height:1400px) {
        .about-body {
            background-size: contain !important;
            height: 70vh !important;
        }
        .about-swiper .swiper-slide {
            width: 350px !important;
            height: 250px !important;
        }
        .about-swiper {
            top: -40% !important;
        }
        .brands-body {
            height: 37vh !important;
        }
        .what-we-do-body {
            height: 50vh !important;
        }
        .parallax-body .intro {
            top: 45% !important;
            left: 50% !important;
        }
        .what-we-do-body .left-area .text-area {
            width: 400px !important;
        }
        .meetus-body {
            height: 75vh !important;
        }
        .scholarship-body {
            height: 50vh !important;
        }
    }
}
@media (min-width:1300px) and (max-width:1400px){
    @media (min-height:1000px) and (max-height:1100px) {
        .what-we-do-body {
            height: 90vh !important;
        }
        .brands-body {
            height: 63vh !important;
        }
        .about-body {
            height: 100vh !important;
        }
        .what-we-do-body .container {
            margin-top:3% !important;
        }
    }
}
@media (min-width:1100px) and (max-width:1200px) {
    @media (min-height:800px) and (max-height:900px) {
        .about-body {
            height: 100vh !important;
        }
        .about-swiper .swiper-slide {
            width: 350px !important;
            height: 250px !important;
        }
        .about-swiper {
            top: -60% !important;
        }
        .brands-body {
            height: 67vh !important;
        }
        .what-we-do-body {
            height: 95vh !important;
        }
        .about-body .frame {
            right: 10% !important;
        }
    }
}
@media (min-width:1000px) and (max-width:1100px){
    @media (min-height:700px) and (max-height:800px) {
        .about-body {
            height: 100vh !important;
        }
        .about-swiper {
            top: -60% !important;
        }
        .what-we-do-body {
            height: 100vh !important;
        }
        .brands-body {
            height: 66vh !important;
        }
    }
}
@media (min-width:800px) and (max-width:900px){
    @media (min-height:1100px) and (max-height:1200px) {
        .about-body {
            height: 75vh !important;
        }
        .brands-body {
            height: 34vh !important;
        }
        .footer-rock {
            top: -25% !important;
            left: -5% !important;
        }
    }
}
@media (max-width:767px) {
    .sidebar-body {
        left: 10% !important;
        top: 80px !important;
    }
    .header-body .stone-img {
        width: 50px !important;
    }
    .header-body .menu-icon {
        left: 30px !important;
    }
    /* .social-body img {
        width: 100% !important;
        object-fit: contain !important;
    } */
    .header-body .title-menu {
        margin-left: -10px !important;
        margin-top: 8px !important;
    }
    .social-youtube {
        width: 40px !important;
        object-fit: contain !important;
    }
    .social-instagram {
        width: 55px !important;
        object-fit: contain !important;
    }
    .logo {
        width: 35% !important;
        object-fit: contain !important;
    }
    .about-body .content-left-border {
        top: 40% !important;
        left: 50% !important;
    }
    .about-body .frame {
        right: -40% !important;
        top: 55% !important;
        z-index: 2 !important;
        background-size: contain !important;
    }
    .about-body .content-right{
        padding: 10px 20px !important; 
    }
    .sidebar-body a::before {
        width: 20px !important;
    }
    .sidebar-body .nav-body::before {
        left: -27px !important;
    }
    .about-swiper {
        top: -30% !important;
    }
    .about-swiper .swiper-slide {
        width: 350px !important;
        height: 250px !important;
    }
    .about-swiper .swiper-slide img{
        width: 100% !important;
    }
    .what-we-do-body h1 {
        margin-top: 100px !important;
    }
    .doMySwiper .swiper-slide {
        width: 100% !important;
        height: 800px !important;
        object-fit: contain !important;
    }
    .doMySwiper .swiper-slide h1 {
        margin-top: 0px !important;
    }
    .doMySwiper .swiper-slide img {
        width: 100% !important;
        height: 400px !important;
        object-fit: contain;
    }
    .doMySwiper .swiper-slide .content-left-border {
        transform: translate(-38%, 150%);
        width: 100% !important;
    }
    .doMySwiper .swiper-slide .text-area {
        padding: 20px 20px !important;
        width: 100% !important;
    }
    .doMySwiper .swiper-slide h1 {
        font-size: 20px !important;
    }
    
    .what-we-do-body .content-left {
        font-size: 11px;
    }
    .backbtn {
        top:75% !important;
    }
    .nextbtn {
        top:75% !important;
    }
    .brands-body {
        height: 100vh !important;
        background-size: cover !important;
    }
    .brands-body .row{
        margin-right: 0px !important;
        margin-left: 0px !important;
        margin-bottom: 20px;
    }
    .about-body .frame {
        width: 350px !important;
    }
    .about-body .content-left {
        width: 300px !important;
    }
    .brands-body .title {
        font-size: 50px !important;
    }
    .what-we-do-body h1 {
        font-size: 50px !important;
    }
    .header-body .title-menu {
        font-size: 12px !important;
    }
    .meetus-body h1 {
        margin-top: 60% !important;
        font-size: 50px !important;
        text-align: center !important;
    }
    .mobile-footer-col {
        top: -30%;
        height: 200px;
    }
    .swiper-slide img {
        object-fit: contain !important;
    }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/media.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;AAClC;AACA;;IAEI;QACI,qBAAqB;QACrB,0CAA0C;IAC9C;IACA;QACI,qBAAqB;QACrB,mBAAmB;QACnB,oBAAoB;IACxB;IACA;QACI,uBAAuB;IAC3B;AACJ;AACA;;IAEI;QACI,qBAAqB;QACrB,0CAA0C;IAC9C;IACA;QACI,qBAAqB;QACrB,mBAAmB;QACnB,oBAAoB;IACxB;IACA;QACI,uBAAuB;IAC3B;AACJ;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,qBAAqB;IACzB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,qBAAqB;QACrB,yCAAyC;IAC7C;IACA;QACI,qBAAqB;QACrB,mBAAmB;QACnB,oBAAoB;IACxB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,oBAAoB;IACxB;IACA;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;IACA;QACI,6BAA6B;QAC7B,6BAA6B;IACjC;IACA;QACI,uBAAuB;QACvB,yBAAyB;IAC7B;IACA;QACI,sBAAsB;QACtB,wBAAwB;QACxB,mBAAmB;QACnB,6BAA6B;QAC7B,sBAAsB;IAC1B;IACA;QACI,sBAAsB;QACtB,wBAAwB;QACxB,8BAA8B;IAClC;IACA;QACI,uBAAuB;QACvB,wBAAwB;QACxB,mBAAmB;IACvB;IACA;QACI,uBAAuB;QACvB,wBAAwB;QACxB,8BAA8B;IAClC;IACA;QACI,8BAA8B;IAClC;IACA;QACI,6BAA6B;IACjC;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,wBAAwB;QACxB,iCAAiC;IACrC;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,4BAA4B;IAChC;IACA;QACI,oBAAoB;IACxB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,+BAA+B;IACnC;IACA;QACI,wBAAwB;IAC5B;IACA;;;;;;;;;OASG;IACH;QACI,wBAAwB;QACxB,sCAAsC;IAC1C;IACA;;;;OAIG;AACP;AACA;IACI;QACI,uBAAuB;QACvB,iCAAiC;IACrC;;AAEJ;AACA;IACI;QACI,wBAAwB;QACxB,iCAAiC;IACrC;IACA;QACI,oBAAoB;IACxB;IACA;QACI,qBAAqB;IACzB;AACJ;AACA;IACI;QACI,oBAAoB;IACxB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,uBAAuB;QACvB,iCAAiC;IACrC;IACA;QACI,kBAAkB;QAClB,uBAAuB;QACvB,SAAS;QACT,UAAU;QACV,qBAAqB;IACzB;AACJ;AACA;IACI;QACI;YACI,oBAAoB;QACxB;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,oBAAoB;QACxB;QACA;YACI,oBAAoB;QACxB;QACA;YACI,uBAAuB;YACvB,sBAAsB;YACtB,mBAAmB;QACvB;QACA;YACI,uBAAuB;QAC3B;IACJ;AACJ;AACA;IACI;QACI;YACI,mBAAmB;YACnB,oBAAoB;QACxB;QACA;YACI,mCAAmC;YACnC,uBAAuB;QAC3B;QACA;YACI,mCAAmC;YACnC,uBAAuB;YACvB,sBAAsB;YACtB,UAAU;QACd;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,oBAAoB;YACpB,oBAAoB;YACpB,qBAAqB;QACzB;QACA;YACI,uCAAuC;YACvC,0BAA0B;QAC9B;QACA;YACI,uBAAuB;YACvB,wBAAwB;QAC5B;QACA;YACI,oBAAoB;QACxB;QACA;YACI,iCAAiC;YACjC,uBAAuB;QAC3B;QACA;YACI,uBAAuB;YACvB,mCAAmC;QACvC;QACA;YACI,sBAAsB;YACtB,wBAAwB;YACxB,8BAA8B;QAClC;QACA;YACI,uBAAuB;YACvB,wBAAwB;YACxB,8BAA8B;QAClC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,6BAA6B;YAC7B,uBAAuB;QAC3B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,8BAA8B;QAClC;IACJ;AACJ;AACA;IACI;QACI;YACI,mCAAmC;YACnC,uBAAuB;QAC3B;QACA;YACI,uBAAuB;YACvB,wBAAwB;QAC5B;QACA;YACI,oBAAoB;QACxB;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,mBAAmB;YACnB,oBAAoB;QACxB;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,uBAAuB;QAC3B;IACJ;AACJ;AACA;IACI;QACI;YACI,uBAAuB;QAC3B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,wBAAwB;QAC5B;IACJ;AACJ;AACA;IACI;QACI;YACI,wBAAwB;QAC5B;QACA;YACI,uBAAuB;YACvB,wBAAwB;QAC5B;QACA;YACI,oBAAoB;QACxB;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,qBAAqB;QACzB;IACJ;AACJ;AACA;IACI;QACI;YACI,wBAAwB;QAC5B;QACA;YACI,oBAAoB;QACxB;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,uBAAuB;QAC3B;IACJ;AACJ;AACA;IACI;QACI;YACI,uBAAuB;QAC3B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,oBAAoB;YACpB,oBAAoB;QACxB;IACJ;AACJ;AACA;IACI;QACI,oBAAoB;QACpB,oBAAoB;IACxB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,qBAAqB;IACzB;IACA;;;OAGG;IACH;QACI,6BAA6B;QAC7B,0BAA0B;IAC9B;IACA;QACI,sBAAsB;QACtB,8BAA8B;IAClC;IACA;QACI,sBAAsB;QACtB,8BAA8B;IAClC;IACA;QACI,qBAAqB;QACrB,8BAA8B;IAClC;IACA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;IACA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,qBAAqB;QACrB,mCAAmC;IACvC;IACA;QACI,6BAA6B;IACjC;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,oBAAoB;IACxB;IACA;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,4BAA4B;IAChC;IACA;QACI,sBAAsB;QACtB,wBAAwB;QACxB,8BAA8B;IAClC;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,sBAAsB;QACtB,wBAAwB;QACxB,mBAAmB;IACvB;IACA;QACI,gCAAgC;QAChC,sBAAsB;IAC1B;IACA;QACI,6BAA6B;QAC7B,sBAAsB;IAC1B;IACA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,wBAAwB;QACxB,iCAAiC;IACrC;IACA;QACI,4BAA4B;QAC5B,2BAA2B;QAC3B,mBAAmB;IACvB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;QAC1B,0BAA0B;QAC1B,6BAA6B;IACjC;IACA;QACI,SAAS;QACT,aAAa;IACjB;IACA;QACI,8BAA8B;IAClC;AACJ","sourcesContent":[".swiper-slide img {\n    object-fit: contain !important;\n}\n@media (min-width:1620px) and (max-width:1880px)\n{\n    .about-body .frame {\n        z-index: 1 !important;\n        transform: translate(-30%,-50%) !important;\n    }\n    .about-body .content-left-border {\n        z-index: 2 !important;\n        top: -5% !important;\n        left: 40% !important;\n    }\n    .about-body .content-left {\n        width: 480px !important;\n    }\n}\n@media (min-width:1400px) and (max-width:1620px)\n{\n    .about-body .frame {\n        z-index: 1 !important;\n        transform: translate(-30%,-50%) !important;\n    }\n    .about-body .content-left-border {\n        z-index: 2 !important;\n        top: -5% !important;\n        left: 35% !important;\n    }\n    .about-body .content-left {\n        width: 380px !important;\n    }\n}\n@media (min-width:1000px) and (max-width:1400px) {\n    .header-body .stone-img {\n        width: 100px !important;\n    }\n    .header-body .menu-icon {\n        left: 53px !important;\n    }\n    .sidebar-body {\n        top: 130px !important;\n    }\n    .about-body .frame {\n        z-index: 1 !important;\n        transform: translate(-5%,-50%) !important;\n    }\n    .about-body .content-left-border {\n        z-index: 2 !important;\n        top: -5% !important;\n        left: 24% !important;\n    }\n    .about-body .content-left {\n        width: 380px !important;\n    }\n    .about-swiper {\n        top: -50% !important;\n    }\n    .about-swiper .swiper-slide {\n        width: 350px !important;\n        height: 250px !important;\n    }\n    .meetus-swiper {\n        position: relative !important;\n        z-index: 999999999 !important;\n    }\n    .meetus-swiper .swiper-slide {\n        width: 200px !important;\n        height: 350px  !important;\n    }\n    .meetus-swiper .swiper-slide img {\n        width: 100% !important;\n        height: 350px !important;\n        object-fit: contain;\n        position: absolute !important;\n        z-index: 20 !important;\n    }\n    .doMySwiper .swiper-slide {\n        width: 100% !important;\n        height: 400px !important;\n        object-fit: contain !important;\n    }\n    .doMySwiper .swiper-slide img {\n        width: 500px !important;\n        height: 400px !important;\n        object-fit: contain;\n    }\n    .doMySwiper .swiper-slide img {\n        width: 600px !important;\n        height: 400px !important;\n        object-fit: contain !important;\n    }\n    .doMySwiper .swiper-slide .content-left-border {\n        transform: translate(20%, 70%);\n    }\n    .doMySwiper .swiper-slide .text-area {\n        padding: 20px 20px !important;\n    }\n    .doMySwiper .swiper-slide h1 {\n        font-size: 20px !important;\n    }\n    .meetus-body {\n        margin-top:25px !important;\n    }\n    .brands-body {\n        height: 103vh !important;\n        background-size: cover !important;\n    }\n    .what-we-do-body h1 {\n        font-size: 50px !important;\n    }\n    .brands-body .title {\n        font-size: 50px !important;\n    }\n    .scholarship-body {\n        margin-top: 100px !important;\n    }\n    .backbtn {\n        top: 90px !important;\n    }\n    .nextbtn {\n        top: 90px !important;\n    }\n    .upper-footer {\n        margin-bottom: 175px !important;\n    }\n    .meetus-body {\n        height: 160vh !important;\n    }\n    /* .meetus-body .mySwiper .swiper-slide{\n       width: 100% !important;\n       height: 400px !important;\n       object-fit: contain !important;\n    }\n    .meetus-body .swiper-slide img {\n        width: 100% !important;\n       height: 400px !important;\n       object-fit: contain !important;\n    } */\n    .scholarship-body {\n        height: 130vh !important;\n        background-position: center !important;\n    }\n    /* .footer-rock {\n        width: 300px !important;\n        bottom: 13% !important;\n        left: 0% !important;\n    } */\n}\n@media (min-width:1000px) and (max-width:1300px) {\n    .brands-body {\n        height: 84vh !important;\n        background-size: cover !important;\n    }\n    \n}\n@media (min-width:1200px) and (max-width:1300px) {\n    .brands-body {\n        height: 103vh !important;\n        background-size: cover !important;\n    }\n    .about-body .content-left-border {\n        left: 30% !important;\n    }\n    .about-body .frame {\n        right: 10% !important;\n    }\n}\n@media (min-width:1300px) and (max-width:1400px) {\n    .about-body .frame {\n        right: 5% !important;\n    }\n    .about-body .content-left-border {\n        left: 35% !important;\n    }\n    .about-swiper {\n        top: -30% !important;\n    }\n    .brands-body {\n        height: 85vh !important;\n        background-size: cover !important;\n    }\n    .footer-rock {\n        position: absolute;\n        width: 400px !important;\n        top: -30%;\n        left: -20%;\n        z-index: 1 !important;\n    }\n}\n@media (min-width:1000px) and (max-width:1100px) {\n    @media  (min-height:600px) and (max-height:650px) {\n        .about-body .frame {\n            right: 0% !important;\n        }\n        .meetus-body {\n            margin-top:50px !important;\n        }\n        .backbtn {\n            top: 90px !important;\n        }\n        .nextbtn {\n            top: 90px !important;\n        }\n        .footer-rock {\n            width: 200px !important;\n            bottom: 13% !important;\n            left: 0% !important;\n        }\n        .what-we-do-body .left-area .text-area {\n            width: 400px !important;\n        }\n    }\n}\n@media (min-width:768px) and (max-width:820px){\n    @media (min-height:1000px) and (max-height:1200px) {\n        .parallax-body .intro {\n            top: 45% !important;\n            left: 50% !important;\n        }\n        .about-body {\n            background-size: contain !important;\n            height: 80vh !important;\n        }\n        .about-body .frame {\n            background-size: contain !important;\n            width: 400px !important;\n            right: -20% !important;\n            z-index: 1;\n        }\n        .about-body .content-left {\n            width: 300px !important;\n        }\n        .about-body .content-left-border {\n            top: -10% !important;\n            left: 30% !important;\n            z-index: 2 !important;\n        }\n        .about-body .content-right {\n            padding: 50px 20px 10px 20px !important;\n            font-size: 14px !important;\n        }\n        .about-swiper .swiper-slide {\n            width: 350px !important;\n            height: 250px !important;\n        }\n        .about-swiper {\n            top: -60% !important;\n        }\n        .brands-body {\n            background-size: cover !important;\n            height: 37vh !important;\n        }\n        .what-we-do-body {\n            height: 52vh !important;\n            background-size: contain !important;\n        }\n        .doMySwiper .swiper-slide {\n            width: 100% !important;\n            height: 450px !important;\n            object-fit: contain !important;\n        }\n        .doMySwiper .swiper-slide img {\n            width: 400px !important;\n            height: 400px !important;\n            object-fit: contain !important;\n        }\n        .doMySwiper .swiper-slide .content-left-border {\n            transform: translate(20%, 70%);\n        }\n        .doMySwiper .swiper-slide .text-area {\n            padding: 20px 20px !important;\n            width: 300px !important;\n        }\n        .what-we-do-body .left-area h1 {\n            font-size: 20px!important;\n        }\n        .backbtn {\n            top: 20% !important;\n        }\n        .nextbtn {\n            top: 20% !important;\n        }\n        .brands-body .title {\n            font-size: 40px !important;\n        }\n        .what-we-do-body h1 {\n            font-size: 40px !important;\n        }\n        .what-we-do-body .mb-5 {\n            margin-bottom: 1rem !important;\n        }\n    }\n}\n@media (min-width:1000px) and (max-width:1100px){\n    @media (min-height:1300px) and (max-height:1400px) {\n        .about-body {\n            background-size: contain !important;\n            height: 70vh !important;\n        }\n        .about-swiper .swiper-slide {\n            width: 350px !important;\n            height: 250px !important;\n        }\n        .about-swiper {\n            top: -40% !important;\n        }\n        .brands-body {\n            height: 37vh !important;\n        }\n        .what-we-do-body {\n            height: 50vh !important;\n        }\n        .parallax-body .intro {\n            top: 45% !important;\n            left: 50% !important;\n        }\n        .what-we-do-body .left-area .text-area {\n            width: 400px !important;\n        }\n        .meetus-body {\n            height: 75vh !important;\n        }\n        .scholarship-body {\n            height: 50vh !important;\n        }\n    }\n}\n@media (min-width:1300px) and (max-width:1400px){\n    @media (min-height:1000px) and (max-height:1100px) {\n        .what-we-do-body {\n            height: 90vh !important;\n        }\n        .brands-body {\n            height: 63vh !important;\n        }\n        .about-body {\n            height: 100vh !important;\n        }\n        .what-we-do-body .container {\n            margin-top:3% !important;\n        }\n    }\n}\n@media (min-width:1100px) and (max-width:1200px) {\n    @media (min-height:800px) and (max-height:900px) {\n        .about-body {\n            height: 100vh !important;\n        }\n        .about-swiper .swiper-slide {\n            width: 350px !important;\n            height: 250px !important;\n        }\n        .about-swiper {\n            top: -60% !important;\n        }\n        .brands-body {\n            height: 67vh !important;\n        }\n        .what-we-do-body {\n            height: 95vh !important;\n        }\n        .about-body .frame {\n            right: 10% !important;\n        }\n    }\n}\n@media (min-width:1000px) and (max-width:1100px){\n    @media (min-height:700px) and (max-height:800px) {\n        .about-body {\n            height: 100vh !important;\n        }\n        .about-swiper {\n            top: -60% !important;\n        }\n        .what-we-do-body {\n            height: 100vh !important;\n        }\n        .brands-body {\n            height: 66vh !important;\n        }\n    }\n}\n@media (min-width:800px) and (max-width:900px){\n    @media (min-height:1100px) and (max-height:1200px) {\n        .about-body {\n            height: 75vh !important;\n        }\n        .brands-body {\n            height: 34vh !important;\n        }\n        .footer-rock {\n            top: -25% !important;\n            left: -5% !important;\n        }\n    }\n}\n@media (max-width:767px) {\n    .sidebar-body {\n        left: 10% !important;\n        top: 80px !important;\n    }\n    .header-body .stone-img {\n        width: 50px !important;\n    }\n    .header-body .menu-icon {\n        left: 30px !important;\n    }\n    /* .social-body img {\n        width: 100% !important;\n        object-fit: contain !important;\n    } */\n    .header-body .title-menu {\n        margin-left: -10px !important;\n        margin-top: 8px !important;\n    }\n    .social-youtube {\n        width: 40px !important;\n        object-fit: contain !important;\n    }\n    .social-instagram {\n        width: 55px !important;\n        object-fit: contain !important;\n    }\n    .logo {\n        width: 35% !important;\n        object-fit: contain !important;\n    }\n    .about-body .content-left-border {\n        top: 40% !important;\n        left: 50% !important;\n    }\n    .about-body .frame {\n        right: -40% !important;\n        top: 55% !important;\n        z-index: 2 !important;\n        background-size: contain !important;\n    }\n    .about-body .content-right{\n        padding: 10px 20px !important; \n    }\n    .sidebar-body a::before {\n        width: 20px !important;\n    }\n    .sidebar-body .nav-body::before {\n        left: -27px !important;\n    }\n    .about-swiper {\n        top: -30% !important;\n    }\n    .about-swiper .swiper-slide {\n        width: 350px !important;\n        height: 250px !important;\n    }\n    .about-swiper .swiper-slide img{\n        width: 100% !important;\n    }\n    .what-we-do-body h1 {\n        margin-top: 100px !important;\n    }\n    .doMySwiper .swiper-slide {\n        width: 100% !important;\n        height: 800px !important;\n        object-fit: contain !important;\n    }\n    .doMySwiper .swiper-slide h1 {\n        margin-top: 0px !important;\n    }\n    .doMySwiper .swiper-slide img {\n        width: 100% !important;\n        height: 400px !important;\n        object-fit: contain;\n    }\n    .doMySwiper .swiper-slide .content-left-border {\n        transform: translate(-38%, 150%);\n        width: 100% !important;\n    }\n    .doMySwiper .swiper-slide .text-area {\n        padding: 20px 20px !important;\n        width: 100% !important;\n    }\n    .doMySwiper .swiper-slide h1 {\n        font-size: 20px !important;\n    }\n    \n    .what-we-do-body .content-left {\n        font-size: 11px;\n    }\n    .backbtn {\n        top:75% !important;\n    }\n    .nextbtn {\n        top:75% !important;\n    }\n    .brands-body {\n        height: 100vh !important;\n        background-size: cover !important;\n    }\n    .brands-body .row{\n        margin-right: 0px !important;\n        margin-left: 0px !important;\n        margin-bottom: 20px;\n    }\n    .about-body .frame {\n        width: 350px !important;\n    }\n    .about-body .content-left {\n        width: 300px !important;\n    }\n    .brands-body .title {\n        font-size: 50px !important;\n    }\n    .what-we-do-body h1 {\n        font-size: 50px !important;\n    }\n    .header-body .title-menu {\n        font-size: 12px !important;\n    }\n    .meetus-body h1 {\n        margin-top: 60% !important;\n        font-size: 50px !important;\n        text-align: center !important;\n    }\n    .mobile-footer-col {\n        top: -30%;\n        height: 200px;\n    }\n    .swiper-slide img {\n        object-fit: contain !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
